const filterResetMiddleware = (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === "LOAD_USER_PROFILE") {
        store.dispatch({ type: "CLEAR_SEARCH_FILTERS", key: "LISTINGS" });
        store.dispatch({ type: "CLEAR_LISTING_SEARCH_RESULTS", tab: "all_km_listings" });
        store.dispatch({ type: "CLEAR_SEARCH_FILTERS", key: "COMPS" });
        store.dispatch({ type: "CLEAR_COMP_SEARCH_RESULTS", tab: "all_km_comps" });
    }

    return result;
};

export default filterResetMiddleware;
